<template>
    <div class="loading-overlay" :class="{'fullscreen': fullscreen, 'overlay': overlay}">
        <animated-loading></animated-loading>
    </div>
</template>

<script>
    export default {
        props: {
            fullscreen: {
                type: Boolean,
                default: false
            },
            overlay: {
                type: Boolean,
                default: false
            },
        }
    }
</script>

<style lang="scss" scoped>
    .loading-animated {
        animation: loading 3s linear infinite;
        transform-origin: center;
        height: 96px;
        width: 96px;

        ::v-deep .path {
            stroke: {
                dashoffset: 0;
                dasharray: 310;
                linecap: round;
            }
            transform-origin: center;
            animation: loading-circle 2s linear infinite;
            stroke: #636c72;
        }
    }

    .status-icon svg {
        vertical-align: initial;
    }

    .loading-overlay {
        align-items: center;
        background-color: #F8F8F8;
        display: flex;
        justify-content: center;
        padding: 2rem;
        z-index: 1040;

        &.fullscreen {
            bottom: 0;
            left: 0;
            position: fixed;
            right: 0;
            top: 0;
        }

        &.overlay {
            background-color: rgba(#F8F8F8, 0.93);
            bottom: 0;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 10;
        }
    }

    .card,
    .modal {
        .loading-overlay {
            background-color: #ffffff;
        }
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes loading-circle {
        0% {
            stroke-dashoffset: 640;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }
</style>